import { Upload, Icon, Modal } from 'antd';
import React, { Component } from 'react';
import API, { API_URL } from '../../../helper/api/Api';

export const uploadFiles = (id, files) => {
  const form = new FormData();

  files.forEach((file) => {
    if (file.url) {
      let imageURL = file.url.split('http://localhost:5000/').join('')
      return API.duplicateImages('/event/' + id + '/duplicate/images', id, imageURL)
    }
    form.append('file[]', file);
  });

  form.append("imagesData", "[]");

  API.msg({
    loading: "Uploading images",
    success: "Images uploaded",
    error: "Images errors"
  })


  return API.file('/event/' + id + '/upload/images', form)
}

export const removeFiles = (id, files) => {

  API.msg({
    success: "Images deleted",
    error: "Images errors"
  })
  
  return files.map(i => API.delete('/event/' + id + '/delete/image/'+ i))
}

export default class UploadImage extends Component {
  state = {
    previewVisible: false,
    previewImage: null,
    uploading: false,
  }

  render() {
    const { previewVisible, previewImage } = this.state;
    const uploadButton = (
        <div>
          <Icon type="plus" />
          <div className="ant-upload-text">Télécharger</div>
        </div>
      );
    const params = {
      action: API_URL + '/event/' + this.props.id + '/upload/images',
      accept: "image/*",
      listType: "picture-card",
      onRemove: (file) => {
        this.props.onRemove(file);
      },
      onPreview : (file) => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true
        });
      },
      beforeUpload: (file) => {
        this.props.onChange(file);

        /*var reader = new FileReader();

        // Closure to capture the file information.
        reader.onload = () => {
          console.log("loader")
          return function(e) {
            console.log("loader 2")
            // Render thumbnail.
            this.setState(({ fileList }) => ({
              fileList: [...fileList, {
                uid: file.uid,
                name: file.name,
                status: 'done',
                thumbUrl: e.target.result,
              } ]
            }));
          };
        };

        // Read in the image file as a data URL.
        reader.readAsDataURL(file);*/

        return false;
      },
      fileList: this.props.files
    };


    return (
        
      <div>
        <Upload {...params}>
            {this.props.files.length >= 3 ? null : uploadButton}
        </Upload>

        <Modal visible={previewVisible} footer={null} onCancel={() => this.setState({ previewVisible : false })}>
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/admin/events/UploadImage.js